<template>
  <apexchart 
    type="pie"
    :width="chartOptions.chart.width" 
    :options="chartOptions"
    :series="series"
  ></apexchart>
</template>

<script>
  export default {
    name: 'PieChart',
    props: {
      labels: Array,
      series: Array,
      width: Number,
    },
    data () {
      return {
        chartOptions: {
          chart: {
            width: this.width ? this.width : 380,
            type: 'pie',
            events: {
              dataPointSelection: function(event, chartContext, config) {
                console.log('event', event)
                console.log('chartContext', chartContext)
                console.log('config', config)
              }
            }
          },
          labels: this.labels,
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
      }
    }
  }
</script>
